<template>
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2705 3.95898C13.3824 3.95898 13.9383 3.95898 14.3377 4.22582C14.5105 4.34134 14.659 4.48978 14.7745 4.66266C15.0413 5.06202 15.0413 5.61795 15.0413 6.72982V14.2507C15.0413 15.7434 15.0413 16.4898 14.5776 16.9536C14.1138 17.4173 13.3675 17.4173 11.8747 17.4173H7.12467C5.63189 17.4173 4.8855 17.4173 4.42176 16.9536C3.95801 16.4898 3.95801 15.7434 3.95801 14.2507V6.72982C3.95801 5.61795 3.95801 5.06202 4.22485 4.66266C4.34037 4.48978 4.4888 4.34134 4.66169 4.22582C5.06104 3.95898 5.61698 3.95898 6.72884 3.95898"
      stroke="url(#paint0_linear_1_20185)"
      stroke-width="1.5"
    />
    <path
      d="M7.125 3.95833C7.125 3.08388 7.83388 2.375 8.70833 2.375H10.2917C11.1661 2.375 11.875 3.08388 11.875 3.95833C11.875 4.83278 11.1661 5.54167 10.2917 5.54167H8.70833C7.83388 5.54167 7.125 4.83278 7.125 3.95833Z"
      stroke="url(#paint1_linear_1_20185)"
      stroke-width="1.5"
    />
    <path
      d="M7.125 9.5L11.875 9.5"
      stroke="url(#paint2_linear_1_20185)"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M7.125 12.666L10.2917 12.666"
      stroke="url(#paint3_linear_1_20185)"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_20185"
        x1="9.49967"
        y1="3.95898"
        x2="9.49967"
        y2="17.4173"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_20185"
        x1="9.5"
        y1="2.375"
        x2="9.5"
        y2="5.54167"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1_20185"
        x1="9.5"
        y1="9.5"
        x2="9.5"
        y2="10.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1_20185"
        x1="8.70833"
        y1="12.666"
        x2="8.70833"
        y2="13.666"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
    </defs>
  </svg>
</template>
